/*
 * $Id:: index.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as NoImageIcon } from '../../assets/images/image_24px.svg';

const useStyles = makeStyles((theme) => ({
    noImage: {
        backgroundImage: theme.palette.image.background,
        backgroundSize: '20px 20px',
        backgroundPosition: '0 0, 0 0, -10px -10px, 10px 10px',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    noImageIcon: {},
}));

const NoImage = () => {
    const classes = useStyles();
    return (
        <div className={classes.noImage}>
            <NoImageIcon className={classes.noImageIcon} />
        </div>
    );
};

export default NoImage;
